import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'
import requestStockMoveReasonEdit from './request/requestStockMoveReasonEdit'
import requestStockMoveReasonRegister from './request/requestStockMoveReasonRegister'
import requestStockMoveRegister from './request/requestStockMoveRegister'
import requestStockMoveShipOperate from './request/requestStockMoveShipOperate'
import requestStockMoveArrivalOperate from './request/requestStockMoveArrivalOperate'

const Actions = {
  // SMR01 在庫移動理由一覧取得
  getStockMoveReasonListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      // .get(apiMock.STOCK_MOVE_REASON_LIST)
      .get(api.STOCK_MOVE_REASON_LIST, { params: params })
      .then((response) => {
        const path = mutationsTypes.STOCK_MOVE_SET_STOCK_MOVE_REASON_LIST
        commit(path, response.data.data)
        const getData = getters.getStockMoveReasonListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // SMR02 在庫移動理由登録
  registerStockMoveReason: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestStockMoveReasonRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.STOCK_MOVE_REASON_REGISTER_EDIT)
      .post(api.STOCK_MOVE_REASON_REGISTER_EDIT, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // SMR03 在庫移動理由編集
  editStockMoveReason: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const req = requestStockMoveReasonEdit.request.createRequest(params)

    return await axios
      // .get(apiMock.STOCK_MOVE_REASON_REGISTER_EDIT)
      .patch(`${api.STOCK_MOVE_REASON_REGISTER_EDIT}/${params.id}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // SMH01 在庫移動履歴一覧取得
  getStockMoveListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      // .get(apiMock.STOCK_MOVE_LIST)
      .get(api.STOCK_MOVE_LIST, { params: params })
      .then((response) => {
        const path = mutationsTypes.STOCK_MOVE_SET_STOCK_MOVE_LIST
        commit(path, response.data.data)

        // ページャーをセット
        const pagePath = mutationsTypes.UI_SET_PAGE_COUNT
        const pageCount = commonUtil.getPageCount(
          response.data.meta.totalRows,
          response.data.meta.perPage
        )
        commit(
          `UI/${pagePath}`,
          { length: pageCount, key: 'storageHistory' },
          { root: true }
        )

        const getData = getters.getStockMoveListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // SM01 在庫移動登録
  registerStockMove: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestStockMoveRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.STOCK_MOVE_REGISTER)
      .post(api.STOCK_MOVE_REGISTER, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // SMH02 在庫移動出庫操作
  operateStockMoveShip: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestStockMoveShipOperate.request.createRequest(params)

    return await axios
      // .get(apiMock.STOCK_MOVE_SHIP_OPERATION)
      .post(`${api.STOCK_MOVE_SHIP_OPERATION}/${params.storageMoveId}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // SMH03 在庫移動到着操作
  operateStockMoveArrival: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestStockMoveArrivalOperate.request.createRequest(params)

    return await axios
      // .get(apiMock.STOCK_MOVE_ARRIVAL_OPERATION)
      .post(`${api.STOCK_MOVE_ARRIVAL_OPERATION}/${params.storageMoveId}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // SMH08 在庫移動履歴微調整
  editStockMove: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    return await axios
      // .get(apiMock.STOCK_MOVE_REGISTER)
      .patch(`${api.STOCK_MOVE_REGISTER}/${params.stockMoveId}`, params)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // SMH07 在庫移動キャンセル
  cancelStockMove: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    return await axios
      // .get(apiMock.STOCK_MOVE_CANCEL)
      .patch(`${api.STOCK_MOVE_CANCEL}/${params.stockMoveId}`)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
